// Global button/link rules (src/index.css, App.css) add a lift, shadow and brand
// colors to every button; these neutralise them for the Book It page.
const RESET =
  "!shadow-none !border-0 hover:!translate-y-0 active:!translate-y-0 !tracking-normal";

export const primaryButton = `${RESET} w-full !rounded-2xl !bg-indigo-600 hover:!bg-indigo-700 active:!scale-[0.98] disabled:!bg-indigo-600 disabled:!opacity-40 disabled:!cursor-not-allowed disabled:active:!scale-100 !text-white !px-4 !py-4 short:!py-3 !text-[21px] !font-semibold !transition-[background-color,opacity,transform] !duration-200 !ease-out`;

export const textButton = `${RESET} !bg-transparent hover:!bg-transparent !p-1 !rounded-md font-[Roboto] !text-[14px] !font-normal !text-slate-500 underline underline-offset-4`;

export const tileButton = `${RESET} w-full text-left !rounded-2xl !p-4 active:!scale-[0.99] !transition-[background-color,border-color,color,transform] !duration-200 !ease-out`;

export const backButton = `${RESET} !bg-transparent hover:!bg-transparent !px-0 !py-1 !text-[17px] !font-semibold !text-slate-900`;
